import React, { useState, useEffect } from "react";
import { Form } from "react-bootstrap";

// Import the states data from a separate file
import { states } from "../data/states";

export default function LocationSelect({
  selectedState,
  selectedCity,
  onStateChange,
  onCityChange,
  stateLabel = "State",
  cityLabel = "City",
  stateRequired = false,
  cityRequired = false,
}) {
  const [availableCities, setAvailableCities] = useState([]);

  // Update available cities when state changes
  useEffect(() => {
    if (selectedState) {
      const state = states.find((s) => s.name === selectedState);
      setAvailableCities(state ? state.cities : []);
    } else {
      setAvailableCities([]);
    }
  }, [selectedState]);

  return (
    <>
      <Form.Group className="mb-3">
        <Form.Label>{stateLabel}</Form.Label>
        <Form.Select
          value={selectedState}
          onChange={(e) => onStateChange(e.target.value)}
          required={stateRequired}
        >
          <option value="">Choose a state</option>
          {states.map((state) => (
            <option key={state.id} value={state.name}>
              {state.name}
            </option>
          ))}
        </Form.Select>
      </Form.Group>

      <Form.Group className="mb-3">
        <Form.Label>{cityLabel}</Form.Label>
        <Form.Select
          value={selectedCity}
          onChange={(e) => onCityChange(e.target.value)}
          disabled={!selectedState}
          required={cityRequired}
        >
          <option value="">Choose a city</option>
          {availableCities.map((city) => (
            <option key={city} value={city}>
              {city}
            </option>
          ))}
        </Form.Select>
      </Form.Group>
    </>
  );
}
